import type { ExposedOverlay } from '@keyvue/one-ui';
import { onMounted, type Ref } from 'vue';
import { onBeforeRouteLeave, onBeforeRouteUpdate } from 'vue-router';

/**
 * should be moved to ui package the moment we figure out a better way to
 * integrate both ui and app with a single router symbol
 */
export default function useOverlayAsRoute(options: {
    overlay: Ref<ExposedOverlay | undefined>,
    isSideSheet: boolean,
    redirectMethod: () => void,
    reloadMethod?: () => Promise<void>
}) {
    onMounted(async () => {
        if (options.reloadMethod) {
            await options.reloadMethod();
        }

        if (options.isSideSheet) {
            await new Promise((resolve) => {
                setTimeout(resolve, 750);
            });

            (options.overlay.value as ExposedOverlay<'open' | 'close' | 'exit'>)?.addOverlayEventListener(
                'exit',
                () => {
                    options.redirectMethod();
                },
            );
        } else {
            options.overlay.value?.addOverlayEventListener('close', () => {
                options.redirectMethod();
            });
        }

        options.overlay.value?.openOverlay();
    });

    onBeforeRouteUpdate(async () => {
        if (options.reloadMethod) {
            await options.reloadMethod();
        }

        options.overlay.value?.openOverlay();
    });

    onBeforeRouteLeave(async () => {
        options.overlay.value?.closeOverlay();

        if (options.isSideSheet) {
            await new Promise((resolve) => {
                setTimeout(resolve, 750);
            });
        }

        return true;
    });
}
